<template>
  <CHeader fixed with-subheader light>
    <CToggler
      in-header
      class="ml-3 d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />
    <CHeaderBrand class="mx-auto d-lg-none" to="/">
      <!--<CIcon name="logo" height="48" alt="Logo"/>-->
      
      <img src="/img/LOGO-250X76.png" height="48" alt="Logo" />
    </CHeaderBrand>
    <CHeaderNav class="d-md-down-none mr-auto">
      
      <!--Cierre de Sesión {{tiempoRestanteSesion}}
      {{porcentajeTiempo}}--> 
      <!--<CIcon class="far fa-battery-full"/>
      <CIcon v-show="porcentajeTiempo >= 80" size="xl" :content="$options.freeSet.cilBattery5" v-c-tooltip.hover="{content:'Cierre de Sesión '+tiempoRestanteSesion, placement:'right'}" />
      <CIcon v-show="porcentajeTiempo < 80 && porcentajeTiempo >= 60" size="xl" :content="$options.freeSet.cilBattery3" v-c-tooltip.hover="{content:'Cierre de Sesión '+tiempoRestanteSesion, placement:'right'}" />
      <CIcon v-show="porcentajeTiempo < 60 && porcentajeTiempo >= 20" size="xl" :content="$options.freeSet.cilBattery0" v-c-tooltip.hover="{content:'Cierre de Sesión '+tiempoRestanteSesion, placement:'right'}" />
      <CIcon v-show="porcentajeTiempo < 20 && porcentajeTiempo >= 5" size="xl" :content="$options.freeSet.cilBatteryAlert" v-c-tooltip.hover="{content:'Cierre de Sesión '+tiempoRestanteSesion, placement:'right'}" />
      <CIcon v-show="porcentajeTiempo < 5 && porcentajeTiempo >= 0" size="xl" :content="$options.freeSet.cilBatterySlash" v-c-tooltip.hover="{content:'Cierre de Sesión '+tiempoRestanteSesion, placement:'right'}" />
      -->
        <progress-bar 
            :options="options"
            :value="porcentajeTiempo"
            v-tippy="{ 
                placement: 'top',
                arrow: true, 
                arrowType: 'round', 
                animation:'fade',
                theme: 'google',
                followCursor : true,
            }"
            :content="'Cierre de Sesión '+tiempoRestanteSesion"
        />
      
      <!--<CHeaderNavItem class="px-3">
        <CHeaderNavLink to="/dashboard">
          Dashboard
        </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink to="/users" exact>
          Users
        </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink>
          Settings
        </CHeaderNavLink>
      </CHeaderNavItem>-->
    </CHeaderNav>
    <CHeaderNav class="mr-4">
      <!--
      <CHeaderNavItem class="d-md-down-none mx-2">
        <CHeaderNavLink>
          <CIcon name="cil-bell"/>
        </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="d-md-down-none mx-2">
        <CHeaderNavLink>
          <CIcon name="cil-list"/>
        </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="d-md-down-none mx-2">
        <CHeaderNavLink>
          <CIcon name="cil-envelope-open"/>
        </CHeaderNavLink>
      </CHeaderNavItem>-->

      <!--<CButton
        variant="ghost"
        size="sm"
        color="success"
        @click="actualizar"
      >
        <CIcon size="sm" :content="$options.freeSet.cilLoopCircular" :class="classActualizar" /> Actualizar
      </CButton>-->

      <!--<Notificaciones />

      <TheHeaderDropdownAccnt/>-->
    </CHeaderNav>
    <!--<CSubheader class="px-3">
      <CBreadcrumbRouter class="border-0 mb-0"/>
    </CSubheader>-->
  </CHeader>
</template>

<script>
//import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'
//import Notificaciones from './Notificaciones'

  import { freeSet } from '@coreui/icons'
  import cons from "@/const";
  import { format, formatDistance, formatRelative, subDays, differenceInMilliseconds, parseISO  } from "date-fns";
  import es from "date-fns/locale/es";
  window.locale = "es";

export default {
  name: 'TheHeaderAdmin',
  freeSet,
  components: {
    //TheHeaderDropdownAccnt,
    //Notificaciones
  },
  data () {
    return {
        classActualizar: "",
        tiempoRestanteSesion: null,
        porcentajeTiempo: 0,
        options: {
            text: {
                color: '#FFFFFF',
                shadowEnable: true,
                shadowColor: '#000000',
                fontSize: 11,
                fontFamily: 'Helvetica',
                dynamicPosition: false,
                hideText: false
            },
            progress: {
                color: '#0b7689',
                backgroundColor: '#333333',
                inverted: false
            },
            layout: {
                height: 25,
                width: 90,
                verticalTextAlign: 61,
                horizontalTextAlign: 43,
                zeroOffset: 0,
                strokeWidth: 30,
                progressPadding: 8,
                type: 'battery'
            }
        },

    }
  },
  
  beforeMount() {
      if(cons.intervalSesionID == null){
                this.obtenerTiempoRestante()

                var idInt = setInterval(function(){
                    this.obtenerTiempoRestante();
                }.bind(this), 3000);

                cons.intervalSesionID = idInt
            }
            
            this.obtenerTiempoRestante()

  },
  
  beforeDestroy () {
      clearInterval(cons.intervalSesionID)
  },
  methods:{
    obtenerTiempoRestante: function(){
        let cookieUsername = this.$cookie.get("userLogginTokenAdmin")
        if(cookieUsername == null){
          this.$router.push("/login/loginAdmin");
        }
        let targetDate = parseISO(JSON.parse(cookieUsername).fechaExpToken)
        let startDate = parseISO(JSON.parse(cookieUsername).fechaIngreso)
        let currentDate = new Date();
        let timeDifference = differenceInMilliseconds(targetDate, currentDate);

        let totalTime = differenceInMilliseconds(targetDate, startDate);
        let porcentajeQueda = ((timeDifference / totalTime) * 100)

        this.porcentajeTiempo = parseInt(porcentajeQueda.toFixed(0));

        if(porcentajeQueda < 0.0001){
          this.$router.push("/login/loginAdmin");
        }
        //console.log("percentageRemaining", percentageRemaining)

      
        /*var tiempo = (cookieUsername === null || cookieUsername === "")?0:formatDistance(new Date(JSON.parse(cookieUsername).fechaExpToken), new Date(), { includeSeconds: false, addSuffix: false, locale: es})
        console.log("tiempo", tiempo)
        if(tiempo != 0){
            if(tiempo=="alrededor de 1 hora"){
            this.porcentajeTiempo = 100
            }
            else{
            this.porcentajeTiempo = (parseInt(tiempo.match(/(\d+)/g)[0])*100)/60
            }
        }*/
        
        this.tiempoRestanteSesion = (cookieUsername === null || cookieUsername === "")?"0 Minutos":formatDistance(new Date(JSON.parse(cookieUsername).fechaExpToken), new Date(), { includeSeconds: true, addSuffix: true, locale: es})
        
        if(cookieUsername === null || cookieUsername === ""){
            clearInterval(cons.intervalSesionID)
            this.$router.push("/login/loginAdmin");
        }
    },
    actualizar: function(){
      this.classActualizar = "imgr"
      

    }
  }
}
</script>

<style >
@keyframes rotate {from {transform: rotate(0deg);}
    to {transform: rotate(360deg);}}
@-webkit-keyframes rotate {from {-webkit-transform: rotate(0deg);}
  to {-webkit-transform: rotate(360deg);}}
.imgr{
    -webkit-animation: 3s rotate linear infinite;
    animation: 3s rotate  linear infinite;
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
}
</style>